module.exports = __webpack_public_path__ + "img/paperclip.a2b9a438.svg";